import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SidebarRightClose.svg",
  "use": "SidebarRightClose.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"SidebarRightClose.svg\"><path d=\"M52,52H12a4,4,0,0,1-4-4V16a4,4,0,0,1,4-4H52a4,4,0,0,1,4,4V48A4,4,0,0,1,52,52ZM31.5556,31.1746l-9.948-6.9888a1.0245,1.0245,0,0,0-1.6183.8191V38.9825a1.0244,1.0244,0,0,0,1.6183.8189l9.948-6.9887A.9969.9969,0,0,0,31.5556,31.1746ZM52,17a1,1,0,0,0-1-1H43a1,1,0,0,0-1,1V47a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol